import { PortfolioAllocation, PortfolioAllocationDataPoint } from '@models';
import { sortPortfolioDataPoints } from '@products/portfolio/portfolio.utils';
import {
  PortfolioQualityAllocationDTO,
  PortfolioDTO,
  PortfolioComponentId,
} from '@types';
import { formatPercentage } from '@utils/text/number-utils';
import { MapperFactory } from '../mapper-factory';
import { Mapper, MapperParams } from '../type.mapper';
import { Logger } from '@utils/logger';
import { getFirstNonEmptyProp, parseStdNumber, parseYN } from '../mapper.utils';

const logger = Logger.getLogger('QualityAllocationMapper');

/**
 * example fund:
 * https://en-us.staging.ftsites.com/investments/options/mutual-funds/products/97/A/templeton-global-bond-fund/TPINX#portfolio
 */
export class QualityAllocationMapper extends Mapper<PortfolioAllocation[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(portfolioDto: PortfolioDTO): PortfolioAllocation[] {
    const data: PortfolioQualityAllocationDTO[] =
      portfolioDto.qualityallocation;
    logger.debug('raw data', data);

    // if no data, return null
    if (!data || data.length === 0) {
      return null;
    }
    const allocation: PortfolioAllocation = {
      componentId: PortfolioComponentId.QUALITY_ALLOCATION,
      baseLabelKey: 'quality-allocation',
      allocationFlag: getFirstNonEmptyProp(data, 'allocflag'),
      allocationHeading: getFirstNonEmptyProp(data, 'allocheadinglocal'),
      asOfDate: getFirstNonEmptyProp(data, 'asofdate'),
      calculationBasis: getFirstNonEmptyProp(data, 'calcbasislocal'),
      // calculationType: getFirstNonEmptyProp(data, 'calctypelocal'), // TODO: calctypelocal doesn't exist in gql
      hasDerivatives: parseYN(getFirstNonEmptyProp(data, 'hasderivatives')),
      hasCurrency: parseYN(getFirstNonEmptyProp(data, 'cashinclude')),
      updateFrequency: getFirstNonEmptyProp(data, 'frequency'),
      benchmarkName: getFirstNonEmptyProp(data, 'bmname'),
      data: data.sort(sortPortfolioDataPoints).map(
        (obj: PortfolioQualityAllocationDTO): PortfolioAllocationDataPoint => ({
          label: obj.qalcbrkwnvalue,
          benchmark: formatPercentage(obj.bmqalcpct),
          benchmarkStd: parseStdNumber(obj.bmqalcpctstd),
          breakdown: formatPercentage(obj.qalcpct),
          breakdownStd: parseStdNumber(obj.qalcpctstd),
        })
      ),
    };
    logger.debug('processed allocation', allocation);
    return [allocation];
  }
}
